import { g as a } from "./index767.mjs";
import { i as o } from "./index778.mjs";
var m = a, t = o, e = m.document, n = t(e) && t(e.createElement), l = function(r) {
  return n ? e.createElement(r) : {};
};
export {
  l as d
};
